<template>
    <div>
        <loading :active.sync="loader" :is-full-page="true" color="#28a745" loader="bars" />
        <div class="modal fade" id="modalWEF" tabindex="-1" role="dialog" aria-labelledby="women" aria-hidden="true"
            data-backdrop="static">
            <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
                <div class="modal-content border-0 shadow">
                    <div class="modal-header bg-light border-bottom">
                        <h5 class="modal-title font-weight-bold text-dark mb-0">
                            Select a Program under the Women’s Enterprise Fund
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div class="modal-body p-4">
                        <div v-for="program in programs" :key="program.title">
                            <!-- Program Info -->
                            <div class="d-flex flex-column flex-md-row align-items-center justify-content-between">
                                <div class="d-flex flex-column flex-md-row align-items-center">
                                    <img :src="program.logo" :alt="program.title + ' Logo'" height="60"
                                        class="mb-3 mb-md-0 mr-md-3" />
                                    <div class="text-center text-md-left">
                                        <h4 class="font-weight-bold text-primary mb-1">
                                            {{ program.title }}
                                        </h4>
                                        <p class="text-muted mb-0">
                                            {{ program.description }}
                                        </p>
                                    </div>
                                </div>
                                <div class="mt-3 mt-md-0" v-if="program.singleLoan">
                                    <button class="btn btn-success rounded-pill px-4 py-2 text-nowrap" disabled
                                        @click="handleApply(program.singleLoan)">
                                        Coming Soon
                                        <!-- <i class="fas fa-arrow-right ml-2"></i> -->
                                    </button>
                                </div>
                            </div>

                            <!-- Loan Options -->
                            <div v-if="program.loans && program.loans.length" class="row mt-4">
                                <div class="col-md-4 mb-3" v-for="loan in program.loans" :key="loan.name">
                                    <div class="card border-0 shadow-sm h-100">
                                        <div class="card-header bg-light border-bottom py-2 px-3">
                                            <h5 class="font-weight-bold mb-0 text-dark">
                                                {{ loan.name }}
                                            </h5>
                                        </div>
                                        <div class="card-body p-3">
                                            <ul class="list-unstyled mb-0">
                                                <li v-for="(item,
                                                    idx) in loan.details" :key="idx" class="mb-2 py-1">
                                                    <i class="fas fa-check text-success mr-2"></i>
                                                    {{ item }}
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="card-footer bg-white border-0 p-3">
                                            <button class="btn btn-success btn-block rounded-pill py-2" disabled v-if="loan.name=='Suki Loan'">
                                                Coming Soon
                                            </button>

                                            <button class="btn btn-success btn-block rounded-pill py-2" v-else
                                                @click="handleApply(loan)">
                                                Apply Now
                                                <i class="fas fa-arrow-right ml-2"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <hr class="my-4" />
                        </div>

                        <div class="mb-5"></div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="modalSukiWEF" tabindex="-1" role="dialog" data-backdrop="static"
            data-keyboard="false">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title bold">
                            For Women’s Enterprise Fund Suki Loan
                        </h5>
                        <button type="button" class="close" @click="closeSuki">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-group">
                            <label>Select Business Type</label>
                            <select class="form-control custom-select-sm">
                                <option selected disabled>- Select -</option>
                                <option value="BT2020001">Sole Proprietorship</option>
                                <option value="BT2020002">Partnership</option>
                                <option value="BT2020004">Corporation</option>
                                <option value="BT2020003">Cooperative</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label>Please enter your Business Name</label>
                            <input class="form-control text-uppercase" />
                        </div>
                        <div class="form-group">
                            <label>Please enter your Promissory Note Number</label>
                            <input class="form-control text-uppercase" />
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-outline-primary btn-sm mr-auto" @click="closeSuki">
                            <i class="fas fa-times mr-1"></i>Cancel
                        </button>
                        <button type="button" class="btn btn-primary btn-sm">
                            Submit<i class="fas fa-arrow-right ml-1"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="modalDocWEF" tabindex="-1" role="dialog" data-backdrop="static"
            data-keyboard="false">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title bold">
                            Documentary Requirements
                        </h5>
                    </div>
                    <div class="modal-body">
                        <div class="card-body mt-n3">
                            <ul style="list-style: '-  '; margin-left: -20px;">
                                <li>
                                    At least one (1) valid ID of the sole
                                    proprietor / managing partner / President /
                                    CEO
                                </li>
                                <li>A selfie holding the same ID</li>
                                <li>
                                    For partnerships and corporations,
                                    Secretary’s Certificate or Board Resolution
                                    or Partnership Resolution that authorizes
                                    the President/CEO/managing partner to
                                    negotiate/obtain a loan from SB Corporation.
                                </li>
                                <li>
                                    Latest General Information Sheet (for
                                    corporations) or Articles of Partnership
                                    (for partnerships).
                                </li>
                                <li>
                                    Proof of bank account or electronic money
                                    account (must be under the name of the sole
                                    proprietor, sole proprietorship,
                                    partnership, or corporation).
                                </li>
                                <li>
                                    Barangay Permit for loan up to PhP100.0
                                    thousand
                                </li>
                                <li>
                                    Mayor’s Permit or Barangay Micro Business
                                    Enterprise (BMBE) Certificate for loan More
                                    than PhP100.0 thousand
                                </li>
                            </ul>

                            <p class="card-text mt-1">
                                - Three (3) pictures showing the following:
                            </p>
                            <ul style="list-style: none; margin-left: -10px;">
                                <li>a. Business signage;</li>
                                <li>b. Inventories; and,</li>
                                <li>c. Fixed assets</li>
                            </ul>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button data-dismiss="modal" class="btn btn-outline-primary mr-auto">
                            <i class="fas fa-times mr-1"></i>Cancel
                        </button>
                        <button type="button" class="btn btn-primary" @click="apiFalahRegistry">
                            Next<i class="fas fa-arrow-right ml-1"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="modalDocSuki" tabindex="-1" role="dialog" data-backdrop="static"
            data-keyboard="false">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title bold">
                            Documentary Requirements
                        </h5>
                    </div>
                    <div class="modal-body">
                        <div class="card-body mt-n3">
                            <p class="card-text bold">
                                If for Fixed assets acquisition
                            </p>
                            <ul style="list-style: '-  '; margin-left: -20px;">
                                <li>Latest GIS (for corporations)</li>
                                <li>
                                    Articles of Partnership (for partnerships)
                                </li>
                                <li>Mayor’s Permit (for the current year)</li>
                                <li>
                                    Secretary’s Certificate or Board Resolution
                                    or Partnership Resolution
                                </li>
                                <li>
                                    Proof of Bank Account or Electronic Money
                                    Account
                                </li>
                                <!-- <li>Three (3) photos and one (1) one-minute video showing the business signage, inventories, and fixed assets</li> -->
                                <li>
                                    Three (3) photos showing the business
                                    signage, inventories, and fixed assets
                                </li>
                            </ul>
                            <hr />
                            <p class="card-text bold">For Other Loan Purpose</p>
                            <ul style="list-style: '-  '; margin-left: -20px;">
                                <li>Latest GIS (for corporations)</li>
                                <li>
                                    Articles of Partnership (for partnerships)
                                </li>
                                <li>Mayor’s Permit (for the current year)</li>
                                <li>
                                    Secretary’s Certificate or Board Resolution
                                    or Partnership Resolution
                                </li>
                                <li>
                                    Proof of Bank Account or Electronic Money
                                    Account
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary">
                            Next<i class="fas fa-arrow-right ml-1"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                programs: [
                    {
                        title: "RISE UP MULTI-PURPOSE",
                        logo: "images/rise1.svg",
                        description:
                            "RISE UP Multi-purpose Loan is for micro, small, and medium multi-sectoral enterprises including existing SBCorp borrowers.",
                        loans: [
                            {
                                name: "Micro Multi-Purpose Loan",
                                details: [
                                    "1+ year business track record",
                                    "Up to ₱300,000"
                                ],
                                program_id: "38",
                                loan_bus_code: "FIB28",
                                app_id_prefix: "WEF",
                                app_id_suffix: "WM"
                            },
                            {
                                name: "First-Time Borrower",
                                details: [
                                    "2+ years business track record",
                                    "Above ₱300,000"
                                ],
                                program_id: "39",
                                loan_bus_code: "FIB29",
                                app_id_prefix: "WEF",
                                app_id_suffix: "WF"
                            },
                            {
                                name: "Suki Loan",
                                details: [
                                    "Existing SBCorp borrowers",
                                    "6+ months repayment history",
                                    "In good standing"
                                ],
                                program_id: "40",
                                loan_bus_code: "FIB30",
                                app_id_prefix: "WEF",
                                app_id_suffix: "WS"
                            }
                        ]
                    },
                    {
                        title: "Business Expansion Financing",
                        logo: "images/startup-logo.png",
                        description:
                            "Support newly established or emerging MSMEs to address capital and operating expense challenges.",
                        singleLoan: {
                            name: "Business Expansion Financing",
                            details: [],
                            code: "FIB12",
                            suffix: "-BE"
                        }
                    },
                    {
                        title: "Franchise Funding",
                        logo: "images/flp-logo2.png",
                        description:
                            "Credit facility for new and existing franchisees, including OFWs and their families.",
                        singleLoan: {
                            name: "Franchise Funding",
                            details: [],
                            code: "FIB13",
                            suffix: "-FF"
                        }
                    },
                    {
                        title: "Purchase Order Financing",
                        logo: "images/pof-logo.png",
                        description:
                            "Provides short-term capital for enterprises with purchase orders from domestic and foreign buyers.",
                        singleLoan: {
                            name: "Purchase Order Financing",
                            details: [],
                            code: "FIB14",
                            suffix: "-FO"
                        }
                    }
                ],
                form: null,
                loader: false
            };
        },
        methods: {
            apiFalahRegistry() {
                $("#modalDocWEF").modal("hide");
                $("#modalWEF").modal("hide");
                this.loader = true;
                axios
                    .post("/api/wef-qualification", {
                        app_id_prefix: this.form.app_id_prefix,
                        app_id_suffix: this.form.app_id_suffix,
                        loan_bus_code: this.form.loan_bus_code
                    })
                    .then(res => {
                        this.loader = false;
                        const data = res.data.loan_process;

                        const mapRoute = {
                            FIB28: "/sblaf-women-enterprise-fund-mp",
                            FIB29: "/sblaf-women-enterprise-fund-ft"
                        };
                        this.$router.push("/apply-loan" + mapRoute[data.loan_type]);
                    })
                    .catch(err => {
                        this.loader = false;
                    });
            },

            closeSuki() {
                $("#modalSukiWEF").modal("hide");
            },
            handleApply(v) {
                this.form = v;
                if (v.loan_bus_code == "FIB28" || v.loan_bus_code == "FIB29") {
                    $("#modalDocWEF").modal("show");
                    this.modalTick();
                }
                // if (v.loan_bus_code == 'FIB30') {
                //     $('#modalSukiWEF').modal('show');
                // }
                else {
                    Swal.fire({
                        icon: "info",
                        title: "Coming Soon!",
                        text:
                            "This loan program will be available shortly. Stay tuned for updates!",
                        confirmButtonText: "Got it!"
                    });
                }
            },
            modalTick() {
                this.$nextTick(() => {
                    $(".modal-backdrop")
                        .first()
                        .css("z-index", "1050");
                    $("#modalWEF").css("z-index", "1051");

                    $(".modal-backdrop")
                        .last()
                        .css({
                            "z-index": "1052",
                            "background-color": "rgba(0,0,0,0.6)"
                        });

                    $("#modalDocWEF").css("z-index", "1053");
                    $("#modalSukiWEF").css("z-index", "1053");
                });
            }
        }
    };
</script>

<style scoped>
    .card {
        transition: all 0.2s ease;
    }

    .card:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    }
</style>